import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bec00c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row my-5 border-primary gx-0" }
const _hoisted_2 = { class: "col-12 border border-primary rounded-3" }

import { ref } from 'vue'
import FormDate from '@/components/form/FormDate.vue'
import AppSelectCardHours from '@/components/AppSelectCardHours.vue'
import { CardInterface } from '@/interfaces/CardInterface'
import { useStore } from 'vuex'
import { VuexStore } from '@/interfaces/VuexStore'
import { key } from '@/setup/store'
import { ActivitiesI } from '@/interfaces/ActivitiesI'


export default /*#__PURE__*/_defineComponent({
  __name: 'TheReserveDay',
  props: {
    actividad: null,
    title: null,
    subtitle: null,
    conAccesoVip: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  actividad: ActivitiesI
  title?: string
  subtitle?: string
  conAccesoVip?: boolean
};



const daySelected = ref({})
const { commit } = useStore<VuexStore>(key)

const completeSelection = (data: CardInterface) => {
  console.log(data)
  commit('COMPLETE_TURNO', { turno: data, dia: daySelected.value })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(FormDate, {
        modelValue: daySelected.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((daySelected).value = $event)),
        "actividad-id": props.actividad.id,
        "tipo-actividad": props.actividad.tipo,
        "con-acceso-vip": props.conAccesoVip
      }, null, 8, ["modelValue", "actividad-id", "tipo-actividad", "con-acceso-vip"]),
      (daySelected.value.id)
        ? (_openBlock(), _createBlock(AppSelectCardHours, {
            key: 0,
            "actividad-id": props.actividad.id,
            dayId: daySelected.value.id,
            onCallback: completeSelection,
            "con-acceso-vip": props.conAccesoVip
          }, null, 8, ["actividad-id", "dayId", "con-acceso-vip"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})